import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './SelectInput.module.sass';

const SelectInput = ({ data }) => {
  return (
    <div>

    </div>
  );
};

SelectInput.propTypes = {
  data: PropTypes.array.isRequired,
};

export default SelectInput;
